<template>
  <div id="messageReply">
    <v-container class="pa-0 mb-4">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>    
    <v-container class="-border">
      <div class="loading-overlay" v-if="loadingMessages">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-layout>
        <v-flex xs12 class="pb-2 pr-4 pl-4">
          <h4> <b>Subject:</b> {{ conversationItem.subject }} </h4>
          <h4 v-if="conversationItem.cc && conversationItem.cc.length"> <b>CC:</b> {{ conversationItem.cc.join(', ') }} </h4>
          <h4 v-if="conversationItem.groups && conversationItem.groups.length"> <b>Groups:</b> {{ Array.from(conversationItem.groups, x => x.name).join(', ') }} </h4>
          <h5>
            <v-icon>{{ conversationItem.human && conversationItem.human.length > 1 ? 'people' : 'person' }}</v-icon>
            <template v-for="(item, index) of conversationItem.human">
              <span :key="index">{{ conversationItem.human.length > 1 ? item.display_name + (conversationItem.human.length - 1 > index ? ', ' : '') : item.display_name }}</span>
            </template>
          </h5>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs12 class="pr-4 pl-4">
          <v-card class="pa-4 mb-3" v-if="conversationItem.message.length">
            <v-card-text class="conversation_content">
                <template v-for="(item, index) of conversationItem.message">
                  <div v-if="item.message.human !== null" v-bind:class="[ session.user().id === item.message.createdBy ? 'reverse' : '']" class="messaging-item layout row my-4" :key="index">
                    <v-avatar class="indigo mx-1" size="32" v-if="session.role() === 'parent'">
                      <template v-if="item.message.human.account">
                        <img class="white" v-if="(item.message.human.account ? item.message.human.account.avatar : '') !== ''" :src="item.message.human.account.avatar" alt="">
                        <span v-else class="white--text subheading pa-3">
                          {{ session.user().id === item.message.createdBy ? Account.name.substr(0,2) : item.message.human.account.name.substr(0,2) }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="white" v-if="(item.message.human.agency ? item.message.human.agency.avatar : '') !== ''" :src="item.message.human.agency.avatar" alt="">
                        <span v-else class="white--text subheading pa-3">
                          {{ session.user().id === item.message.createdBy ? Agency.name.substr(0,2) : item.message.human.agency.name.substr(0,2) }}
                        </span>
                      </template>
                    </v-avatar>
                    <v-avatar class="indigo mx-1" size="32" v-else>
                      <template v-if="item.message.human.account">
                        <img class="white" v-if="(item.message.human.account ? item.message.human.account.avatar : Account.avatar) !== ''" :src="[item.message.human.account ? item.message.human.account.avatar : Account.avatar]" alt="">
                        <span v-else class="white--text subheading pa-3">
                          {{ session.user().id === item.message.createdBy ? Agency.name.substr(0,2) : conversationItem.human[0].display_name.substr(0,2) }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="white" v-if="(item.message.human.agency ? item.message.human.agency.avatar : Agency.avatar) !== ''" :src="[item.message.human.agency ? item.message.human.agency.avatar : Agency.avatar]" alt="">
                        <span v-else class="white--text subheading pa-3">
                          {{ session.user().id === item.message.createdBy ? Agency.name.substr(0,2) : conversationItem.human[0].display_name.substr(0,2) }}
                        </span>
                      </template>
                    </v-avatar>
                    <div>
                      <div class="messaging--body column mx-2">
                        <v-layout v-if="session.getSession().adminUser" v-bind:class="[ session.user().id !== item.message.createdBy ? 'closeIcon' : 'closeIconReverse']" row justify-end class="text--secondary">
                          <v-flex xs4 class="pa-0 ma-0 text-xs-right">
                            <v-icon class="icon-color pa-1" size="15" title="Delete" @click="deleteMessage(item.message)">
                              close
                            </v-icon>
                          </v-flex>
                        </v-layout>
                        <div class="message" v-html="item.message.content"></div>
                      </div>
                      <v-container py-0 px-2 ma-0 v-if="session.user().id === item.message.createdBy">
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs4 class="pa-0 ma-0 text-xs-left seen" v-if="item.message.is_seen === true && item.message.createdBy == session.user().id" >
                            <v-icon small color="blue lighten-3">
                              fas fa-circle
                            </v-icon>
                            Seen
                          </v-flex>
                          <v-flex v-else xs4 class="pa-0 ma-0 text-xs-left seen">
                          </v-flex>
                          <v-flex xs8 class="pa-0 ma-0  text-xs-right">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <v-container v-else py-0 px-2 ma-0>
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs8 class="pa-0 ma-0 text-xs-left">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                          <v-flex xs4 class="pa-0 ma-0  text-xs-right">
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                    <v-spacer></v-spacer>
                  </div>
                </template>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-form ref="formEdit" v-if="!session.getSession().adminUser">
        <v-layout>
          <v-flex>
            <div id="pageEditor" >
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption" :content="content" :init="{ height: 300, menubar: false}" :api-key="apikey" v-model="message.content" @input="changedData" :rules="[rules.contentRule]" />
                    <!-- <quill-editor
                      :class="{'height-300': $vuetify.breakpoint.smAndUp}"
                      :content="content"
                      :options="editorOption"
                      @input="changedData"
                      v-model="message.content"
                      :rules="[rules.contentRule]"
                    >
                    </quill-editor> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right" v-if="selectedData">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
/* global session router store config */
/* import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; */
import Editor from '@tinymce/tinymce-vue';

import swal from 'sweetalert2';
import { getCollection, create, getOne, formatDate, update, remove, conversationListPopulate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'replyMessage',
  components: {
    Editor
  },
  data: () => ({
    entity: 'Message',
    editor: null,
    config: config,
    apikey: config.tinymceEditorKey,
    content: '',
    selectedData: false,
    editorOption: {
      placeholder: 'Enter your reply.',
    },
    conversationId: '',
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversationItem: {
      message: []
    },
    conversationIndex: '',
    rules: {
      contentRule: (v) => !!v || 'Please enter reply',
    },
    loadingMessages: true,
    agencyFamiliesList: [],
    agencyAdminList: [],
  }),
  computed: {
    ...mapGetters(['Agency', 'Account']),
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    Message: {
      get () {
        return store.state.Message;
      },
      set (value) {
        store.commit('setMessage', value);
      }
    },
    ContactList: {
      get () {
        return store.state.ContactList;
      },
      set (value) {
        store.commit('setContactList', value);
      }
    }
  },
  watch: {
    Conversation (value) {
      this.conversationItem = this.Conversation.find(x => x._id === this.conversationId);
      // Read the new messages
      this.updateReadStatus();
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    if (session.isOnline()) {
      this.role = session.getSession().user.role;
    }
    this.conversationId = this.$route.params.conversationId;
    await this.initializeConversation();
    window.getApp.$emit('pageSubHeader', 'Reply');
    await this.updateReadStatus();
  },
  mounted () {
    //
  },
  methods: {
    async deleteMessage (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let sessionUser = session.getSession();
            let Message = JSON.parse(JSON.stringify(item));
            Message.removed.push(sessionUser.user.human.id);
            Message.human = Message.human.id;
            let { error, data, status } = await update('Message', Message, Message.id);
            if (error) {
              console.log('error', error);
            } else {
              swal.fire({
                type: 'success',
                title: `Message deleted Successfully`,
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  this.initializeConversation();
                }
              });
            }
          })();
        }
      });
    },
    async initializeConversation () {
      this.loadingMessages = true;
      let sort = { 'updatedAt': -1 };
      let sessionUser = session.getSession();
      let where = {};
      where = {
        $and: [
          {
            $or: [
              {
                human: sessionUser.user.human.id
              }
            ]
          },
          {
            $or: [
              {
                archive: { $exists: false }
              },
              {
                archive: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          },
          {
            $or: [
              {
                removed: { $exists: false }
              },
              {
                removed: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          }
        ]
      };
      if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
        where.$and[0].$or.push({
          groups: {
            $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
          }
        });
      }
      let { error, data } = await getCollection('Conversation', true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Conversation = data;
        }
      }
      this.loadingMessages = false;
      this.conversationItem = await this.Conversation.find(x => x._id === this.conversationId);
      this.conversationItem.message = await this.conversationItem.message.filter(message => message.message.human);
      if (session.getSession().adminUser && this.conversationItem.message && this.conversationItem.message.length === 0) {
        this.backToListing();
      }
      this.conversationIndex = this.Conversation.findIndex(x => x._id === this.conversationId);
    },
    async save () {
      if (this.$refs.formEdit.validate()) {
        this.selectedData = false;
        this.message.conversation = this.conversationId;
        let sessionUser = session.getSession();
        this.message.sender = ['agency', 'caseworker'].indexOf(session.role()) > -1 ? this.Agency.human[0] : this.Account.human[0].id;
        let { error, data, status } = await create(this.entity, this.message);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          let messageData = {};
          let accountAgency =  session.role() === 'parent' ? this.Account : this.Agency;
          let humanData = {
            birth_date: accountAgency.human[0].birth_date,
            id: accountAgency.human[0].id,
            user: accountAgency.human[0].user,
            _id: accountAgency.human[0]._id
          };
          if (session.role() === 'parent') {
            humanData.account = {
              avatar: accountAgency.avatar,
              id: accountAgency.id,
              name: accountAgency.name,
              ppn: accountAgency.ppn,
              _id: accountAgency._id
            };
          } else {
            humanData.agency = {
              avatar: accountAgency.avatar,
              id: accountAgency.id,
              name: accountAgency.name,
              _id: accountAgency._id
            };
          }
          data.human = humanData;
          messageData.message = data;
          this.Conversation[this.conversationIndex].message.push(messageData);
          this.Conversation[this.conversationIndex].last_message = data;
          swal.fire({
            type: 'success',
            title: 'Message sent successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.message.content = '';
              this.backToListing();
              // this.$router.push({ path: '/messages' });
            }
          });
        }
      }
    },
    changedData () {
      let strippedText = this.message.content.replace(/(<([^>]+)>)/ig, '');
      strippedText = strippedText.trim();
      if (strippedText.length > 0) {
        this.selectedData = true;
      } else {
        this.selectedData = false;
      }
    },
    hideButtons () {
      this.selectedData = false;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      if (this.$route.query.preUrl === 'dashboard') {
        this.$router.push({ path: session.role() === 'parent' ? `/dashboard` : `/agency/dashboard` });
      } else {
        this.$router.push({ path: `/messages` });
      }
    },
    formatDate (dateString, format) {
      return formatDate(dateString, format);
    },
    async updateReadStatus () {
      // Update if logged in user is the recipient
      if (!session.getSession().adminUser) {
        this.conversationItem.message.forEach(async (element, index) => {
          if (element.message && element.message.human && element.message.createdBy !== session.user().id && element.message.is_seen === false) {
            element.message.is_seen = true;
            let updateData = JSON.parse(JSON.stringify(element.message));
            updateData.human = updateData.human.id;
            let { error, data, status } = await update('Message', updateData, updateData.id);
            if (error) {
              console.log('error', error);
            } else {
              this.Conversation[this.conversationIndex].message[index].message.is_seen = this.Conversation[this.conversationIndex].last_message.is_seen = true;
            }
          }   
        });
      }
    },
  }
};
</script>

<style lang="css" scoped>

.loading-overlay {
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
}
  .editor-button-container{
    padding-top: 70px;
  }
  .message-body {
    padding-top: 15px;
  }
  
.message-list {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 1px;
  margin-top: 1px;
}
.messaging--body {
  padding: 10px 0px;
  margin-top: 10px !important;
  border-radius: 0rem 1.25rem 1.25rem 1.25rem;
  background-color: #64B5F6;
  color: #fff;
  transition: all .3s cubic-bezier(.23,1,.32,1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  position: relative;
  min-width: 150px;
}
.reverse .messaging--body {
  border-radius: 1.25rem 0rem 1.25rem 1.25rem;
  background-color: #ECECEC;
  color: #333;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
}
.messaging--title {
  padding: 0px 0px 5px 15px;
  text-align: start;
  overflow: auto;
}
.messaging--title .messageRead{
  float: right;
  margin-right: 10px;
}
.messaging--title .human {
  font-size: 14px;
  font-weight: bold;
}
.messaging--title .time {
  font-size: 12px;
  display: inline-block;
}
.messaging-item {
  margin: 0px !important;
}
.messaging--body .message >>> img {
  width: 600px !important;
}
.messaging--body .message >>> p {
  margin: 0px !important;
}
.messaging--body .message {
  margin: 0px 15px;
  text-align: left;
}
.seen .v-icon{
  font-size: 6px !important;
  vertical-align: middle;
}
.seen {
  color: #64B5F6;
}
.unReadList {
  position: absolute;
  right: 0px;
  padding: 15px 10px;
}
.unReadList .v-icon{
  font-size: 10px !important;
 }
 .unread-row .v-list__tile__title, .unread-row .v-list__tile__sub-title {
  font-weight: 800 !important;
 }
 .v-card--reveal, .v-card--add-contact {
  z-index: 1;
  top: -51px;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  background-color: #fff;
}
.avatar-chat {
  margin-left: -10px;
  -webkit-box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}
.chat-room--toolbar {
  min-height: 48px !important;
}
.chat-room--toolbar .v-toolbar__title{
  font-size: 16px;
  font-weight: 400;
  white-space: normal;
  text-align: center;
}

.closeIcon  {
    position: absolute;
    top: -9px;
    right: 8px;
}

.closeIcon .icon-color, .closeIconReverse .icon-color {
  background: #f195bf !important;
  color: white;
  cursor: pointer;
  border-radius: 50%;
}

.closeIconReverse {
    position: absolute;
    top: -10px;
    left: -20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Messages/reply.vue